import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  eventObject: {}
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/event/vuex/index.js